import React from 'react';
import { Container, Row, Col, Fade, Jumbotron, Button } from 'reactstrap';
import logo from '../../assets/img/chatLogo.png';

const LandingView = () => (
  <Fade>
    <Container fluid className="mt-3">
      <Row className="vh-100">
        <Col className="">
          <Jumbotron fluid>
            <Container fluid>
              <Row>
                <Col xs={9}>
                  <h1 className="display-3">
                    <strong>C</strong>ommunicating
                    <br />
                    <strong>H</strong>ealthcare
                    <br />
                    <strong>A</strong>lternatives
                    <br />
                    <strong>T</strong>ool
                  </h1>
                  <p className="lead">
                    <Button className="float-left">Learn More</Button>
                  </p>
                </Col>
                <Col>
                  <img src={logo} className="img-fluid" alt="CHAT_LOGO" />
                </Col>
              </Row>
            </Container>
          </Jumbotron>
        </Col>
      </Row>
    </Container>
  </Fade>
);
export default LandingView;
